/* Sale Maceteros: filtro propio y server-first. */
(function () {
  'use strict';

  var GROUP_ORDER = ['tamano', 'color', 'caracteristicas'];
  var GROUPS = {
    tamano: ['maceteros-pequenos', 'maceteros-medianos', 'maceteros-grandes', 'maceteros-extra-grande'],
    color: ['negro', 'blanco', 'cafe', 'arena', 'gris', 'terracota'],
    caracteristicas: ['liviano']
  };
  var LABELS = {
    'maceteros-pequenos': 'Pequeños',
    'maceteros-medianos': 'Medianos',
    'maceteros-grandes': 'Grandes',
    'maceteros-extra-grande': 'Extra grandes',
    negro: 'Negro',
    blanco: 'Blanco',
    cafe: 'Café',
    arena: 'Arena',
    gris: 'Gris',
    terracota: 'Terracota',
    liviano: 'Liviano'
  };

  function init() {
    var root = document.querySelector('[data-sale-plp-root][data-sale-collection-handle="sale-maceteros"][data-ch-filter-count-owner="sale-maceteros"]');
    if (!root) return;

    var dataNode = document.getElementById('ch-sm-data');
    var drawer = root.querySelector('[data-ch-sale-maceteros-drawer]');
    var panel = drawer && drawer.querySelector('.ch-sm__panel');
    if (!dataNode || !drawer || !panel) return;

    document.body.classList.add('ch-sale-maceteros-filter');

    var products = [];
    try { products = JSON.parse(dataNode.textContent || '[]'); } catch (error) { products = []; }

    var collectionUrl = (root.getAttribute('data-sale-collection-url') || '/collections/sale-maceteros').replace(/\/+$/, '');
    var defaultSort = drawer.getAttribute('data-ch-sale-maceteros-default-sort') || 'manual';
    var selected = selectionFromPath(window.location.pathname);
    var applied = copySelection(selected);
    var selectedSort = new URLSearchParams(window.location.search).get('sort_by') || defaultSort;
    var appliedSort = selectedSort;
    var activePage = root.querySelector('[data-ch-sale-maceteros-active-page]');
    var applyButton = drawer.querySelector('[data-ch-sale-maceteros-apply]');
    var totalNode = drawer.querySelector('[data-ch-sale-maceteros-total]');
    var lastOpener = null;
    var requestId = 0;
    var inertRecords = [];

    // --- Contrato transversal compartido por los cinco filtros propios
    //     (assets/chagual-filter-contract.js). Resolucion perezosa y tolerante:
    //     si esa capa no cargo, el filtro sigue operando igual que antes. ---
    function shared(name) {
      var api = window.ChagualFilterContract;
      var fn = api && api[name];
      return typeof fn === 'function' ? fn : function () {};
    }

    function appliedFacets() {
      var facets = GROUP_ORDER.filter(function (group) { return applied[group]; })
        .map(function (group) { return { facet: group, value: applied[group] }; });
      if (appliedSort && appliedSort !== defaultSort) facets.push({ facet: 'orden', value: appliedSort });
      return facets;
    }

    function copySelection(value) {
      var copy = {};
      GROUP_ORDER.forEach(function (group) { if (value[group]) copy[group] = value[group]; });
      return copy;
    }

    function openers() {
      return Array.prototype.slice.call(document.querySelectorAll('[data-ch-sale-maceteros-filter-open],[data-ch-sale-maceteros-sort-open]'));
    }

    function syncOpeners(active) {
      openers().forEach(function (opener) {
        opener.setAttribute('aria-controls', drawer.id);
        opener.setAttribute('aria-expanded', active && opener === lastOpener ? 'true' : 'false');
      });
    }

    function selectionFromPath(pathname) {
      var next = {};
      var parts = String(pathname || '').split('/').filter(Boolean);
      var collectionIndex = parts.indexOf('collections');
      var tail = collectionIndex >= 0 && parts.length > collectionIndex + 2 ? parts[collectionIndex + 2] : '';
      if (!tail) return next;
      var tags;
      try { tags = decodeURIComponent(tail).toLowerCase().split('+'); } catch (error) { tags = tail.toLowerCase().split('+'); }
      GROUP_ORDER.forEach(function (group) {
        GROUPS[group].some(function (tag) {
          if (tags.indexOf(tag) === -1) return false;
          next[group] = tag;
          return true;
        });
      });
      return next;
    }

    function tagsFor(value) {
      return GROUP_ORDER.map(function (group) { return value[group]; }).filter(Boolean);
    }

    function productMatches(product, tags) {
      var productTags = product && product.t ? product.t : [];
      return tags.every(function (tag) { return productTags.indexOf(tag) !== -1; });
    }

    function countForTags(tags) {
      return products.reduce(function (total, product) { return total + (productMatches(product, tags) ? 1 : 0); }, 0);
    }

    function countForOption(tag, group) {
      var tags = GROUP_ORDER.filter(function (candidate) { return candidate !== group; })
        .map(function (candidate) { return selected[candidate]; }).filter(Boolean);
      tags.push(tag);
      return countForTags(tags);
    }

    function selectedTotal() { return countForTags(tagsFor(selected)); }

    function renderDrawer() {
      Array.prototype.forEach.call(drawer.querySelectorAll('[data-ch-sale-maceteros-filter]'), function (button) {
        var tag = button.getAttribute('data-tag');
        var group = button.getAttribute('data-group');
        var isSelected = selected[group] === tag;
        var count = countForOption(tag, group);
        button.classList.toggle('is-selected', isSelected);
        button.setAttribute('aria-checked', isSelected ? 'true' : 'false');
        button.setAttribute('aria-disabled', count === 0 && !isSelected ? 'true' : 'false');
        var countElement = button.querySelector('[data-ch-sale-maceteros-count]');
        if (countElement) countElement.textContent = String(count);
      });
      Array.prototype.forEach.call(drawer.querySelectorAll('[data-ch-sale-maceteros-sort]'), function (button) {
        var isSelected = button.getAttribute('data-ch-sale-maceteros-sort') === selectedSort;
        button.classList.toggle('is-selected', isSelected);
        button.setAttribute('aria-checked', isSelected ? 'true' : 'false');
      });
      if (totalNode) totalNode.textContent = String(selectedTotal());
      // B9: una sola parada de tabulacion por grupo de botones de opcion.
      shared('refreshRoving')(drawer);
    }

    function renderActivePage() {
      if (!activePage) return;
      var tags = tagsFor(applied);
      if (!tags.length) {
        activePage.hidden = true;
        activePage.innerHTML = '';
        return;
      }
      activePage.hidden = false;
      activePage.innerHTML = GROUP_ORDER.map(function (group) {
        var tag = applied[group];
        if (!tag) return '';
        return '<button type="button" class="ch-sm-active-page__chip" data-ch-sale-maceteros-remove="' + group + '">' +
          '<span>' + LABELS[tag] + '</span><span aria-hidden="true">&times;</span>' +
          '<span class="ch-sm__sr">Quitar filtro ' + LABELS[tag] + '</span></button>';
      }).join('');
    }

    function buildUrl(value, sort, page) {
      var tags = tagsFor(value);
      var url = tags.length ? collectionUrl + '/' + tags.join('+') : collectionUrl;
      var params = new URLSearchParams();
      if (sort && sort !== defaultSort) params.set('sort_by', sort);
      if (page && page > 1) params.set('page', String(page));
      var query = params.toString();
      return query ? url + '?' + query : url;
    }

    function resultsNode(scope) {
      if (scope && scope.matches && scope.matches('[data-ch-filter-results][data-ch-filter-owner="sale-maceteros"]')) return scope;
      return (scope || document).querySelector('[data-ch-filter-results][data-ch-filter-owner="sale-maceteros"]');
    }

    function resultsTotal(scope) {
      var results = resultsNode(scope);
      if (!results) return null;
      var total = parseInt(results.getAttribute('data-ch-filter-total'), 10);
      return isNaN(total) || total < 0 ? null : total;
    }

    function setGridCount(total) {
      var count = root.querySelector('[data-sale-grid-count]');
      if (!count) return;
      count.setAttribute('data-ch-filter-count-current', String(total));
      count.textContent = total === 1 ? '1 producto' : total + ' productos';
    }

    function emitCatalogUpdated(total, url) {
      document.dispatchEvent(new CustomEvent('chagual:catalog-updated', {
        detail: { owner: 'sale-maceteros', total: total, url: url }
      }));
    }

    // --- Cambio de pagina accesible (hallazgo P1 numero 3 de la auditoria 16).
    //     Antes el swap reemplazaba el resultado y dejaba al cliente donde estaba,
    //     con el foco perdido y sin aviso. Ahora: anuncio en la region viva que
    //     sobrevive al swap, foco al inicio del resultado y vista controlada. ---
    function announceResults(page, pages, total) {
      var status = root.querySelector('[data-ch-filter-status]');
      if (!status) return;
      var message = total === 1 ? '1 producto' : total + ' productos';
      if (pages > 1 && page > 0) message = 'Página ' + page + ' de ' + pages + '. ' + message;
      status.textContent = message + '.';
    }

    function headerOffset() {
      if (typeof window.getComputedStyle !== 'function' || !document.documentElement) return 0;
      var raw = window.getComputedStyle(document.documentElement).getPropertyValue('--chagual-header-offset');
      var value = parseFloat(raw);
      return isFinite(value) && value > 0 ? value : 0;
    }

    function focusResultsStart(node) {
      if (!node) return;
      try { node.focus({ preventScroll: true }); } catch (error) { node.focus(); }
      if (typeof node.getBoundingClientRect !== 'function' || typeof window.scrollTo !== 'function') return;
      var top = node.getBoundingClientRect().top + (window.pageYOffset || 0) - headerOffset() - 8;
      window.scrollTo(0, top > 0 ? top : 0);
    }

    // `action` describe que hizo la persona: alimenta la medicion compartida
    // (auditoria 24, huecos 1, 2, 3 y 5) sin cambiar el flujo del swap. Sin
    // `action` explicito es restauracion de historial y no se mide.
    function swapResults(url, pushHistory, returnFocus, action) {
      var intent = action || 'history';
      var live = resultsNode(root);
      if (!live || typeof fetch !== 'function') {
        shared('trackFallback')('sale-maceteros', 'sin-fetch', url);
        window.location.assign(url);
        return;
      }
      var currentRequest = ++requestId;
      shared('beginBusy')(root);
      fetch(url, { headers: { 'X-Requested-With': 'fetch' }, credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Respuesta invalida');
          return response.text();
        })
        .then(function (html) {
          if (currentRequest !== requestId) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshRoot = doc.querySelector('[data-sale-plp-root][data-sale-collection-handle="sale-maceteros"][data-ch-filter-count-owner="sale-maceteros"]');
          var fresh = freshRoot && resultsNode(freshRoot);
          live = resultsNode(root);
          var total = resultsTotal(fresh);
          var freshPage = fresh ? parseInt(fresh.getAttribute('data-ch-filter-page'), 10) : NaN;
          var expectedInfeedCount = freshPage === 1 && total > 0 ? 1 : 0;
          var infeedCount = fresh ? fresh.querySelectorAll('[data-sale-infeed-shell]').length : 0;
          if (!fresh || !live || total == null || isNaN(freshPage) || infeedCount !== expectedInfeedCount) { shared('trackFallback')('sale-maceteros', 'respuesta-incompleta', url); window.location.assign(url); return; }
          if (!window.ChagualCollectionSeoSync || !window.ChagualCollectionSeoSync.apply(doc)) { shared('trackFallback')('sale-maceteros', 'sin-seo-sync', url); window.location.assign(url); return; }
          var previousPage = parseInt(live.getAttribute('data-ch-filter-page'), 10);
          var freshPages = parseInt(fresh.getAttribute('data-ch-filter-pages'), 10);
          live.replaceWith(fresh);
          if (pushHistory !== false && window.history && window.history.pushState) {
            window.history.pushState({ chagualCatalog: 'sale-maceteros' }, '', url);
          }
          setGridCount(total);
          closeDrawer(returnFocus === true);
          announceResults(freshPage, freshPages, total);
          if (!isNaN(freshPage) && !isNaN(previousPage) && freshPage !== previousPage) focusResultsStart(fresh);
          emitCatalogUpdated(total, url);
          // Medicion compartida: faceta, valor y cantidad de resultados.
          if (intent === 'clear') shared('trackClear')('sale-maceteros', total, url, 'drawer');
          else if (intent === 'apply') shared('trackApply')('sale-maceteros', appliedFacets(), total, url);
        })
        .catch(function () {
          if (currentRequest === requestId) {
            shared('trackFallback')('sale-maceteros', 'peticion-fallida', url);
            window.location.assign(url);
          }
        })
        // B10: solo la respuesta vigente puede dar por terminada la carga. Sin
        // esta guarda una peticion vieja retiraba el estado ocupado que habia
        // puesto la nueva. El modelo es chagual-sale-root-filter.js.
        .then(function () { shared('endBusy')(root, currentRequest === requestId); });
    }

    function markInert(element) {
      if (!element || element.nodeType !== 1) return;
      var record = { element: element, inert: false, aria: false };
      if (!element.hasAttribute('inert')) { element.setAttribute('inert', ''); record.inert = true; }
      if (!element.hasAttribute('aria-hidden')) { element.setAttribute('aria-hidden', 'true'); record.aria = true; }
      if (record.inert || record.aria) inertRecords.push(record);
    }

    function setBackgroundInert(on) {
      if (on) {
        var node = drawer;
        while (node && node.parentNode && node !== document.body) {
          Array.prototype.forEach.call(node.parentNode.children, function (sibling) { if (sibling !== node) markInert(sibling); });
          node = node.parentNode;
        }
      } else {
        inertRecords.forEach(function (record) {
          if (record.inert) record.element.removeAttribute('inert');
          if (record.aria) record.element.removeAttribute('aria-hidden');
        });
        inertRecords = [];
      }
    }

    function focusables() {
      return Array.prototype.slice.call(panel.querySelectorAll('button:not([disabled]):not([aria-disabled="true"]),a[href],[tabindex]:not([tabindex="-1"])'))
        .filter(function (element) { return element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement; });
    }

    function openDrawer(opener, group) {
      lastOpener = opener || lastOpener;
      drawer.hidden = false;
      drawer.removeAttribute('inert');
      drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.add('is-open');
      document.body.classList.add('ch-sm-lock');
      setBackgroundInert(true);
      syncOpeners(true);
      renderDrawer();
      var target = drawer.querySelector('[data-ch-sale-maceteros-group="' + (group || 'tamano') + '"]');
      var first = target && target.querySelector('[role="radio"]');
      try { (first || panel).focus({ preventScroll: true }); } catch (error) { (first || panel).focus(); }
      if (target) target.scrollIntoView({ block: 'start' });
    }

    function closeDrawer(returnFocus) {
      var wasOpen = drawer.classList.contains('is-open');
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.hidden = true;
      drawer.setAttribute('inert', '');
      document.body.classList.remove('ch-sm-lock');
      setBackgroundInert(false);
      syncOpeners(false);
      if (returnFocus !== false && wasOpen && lastOpener && typeof lastOpener.focus === 'function') lastOpener.focus();
    }

    document.addEventListener('click', function (event) {
      var filterOpen = event.target.closest && event.target.closest('[data-ch-sale-maceteros-filter-open]');
      var sortOpen = event.target.closest && event.target.closest('[data-ch-sale-maceteros-sort-open]');
      if (filterOpen || sortOpen) {
        event.preventDefault();
        openDrawer(filterOpen || sortOpen, sortOpen ? 'orden' : 'tamano');
        return;
      }
      var remove = event.target.closest && event.target.closest('[data-ch-sale-maceteros-remove]');
      if (remove) {
        event.preventDefault();
        var group = remove.getAttribute('data-ch-sale-maceteros-remove');
        delete selected[group];
        delete applied[group];
        renderDrawer();
        renderActivePage();
        // B12: el chip pulsado desaparece; el foco pasa al chip siguiente y, si
        // no queda ninguno, al boton que abre el cajon. Patron copiado de
        // chagual-maceteros-filter.js a traves del contrato compartido.
        shared('focusAfterChipRemoval')(activePage, '[data-ch-sale-maceteros-remove]', document.querySelector('[data-ch-sale-maceteros-filter-open]'));
        swapResults(buildUrl(applied, appliedSort), true, false, tagsFor(applied).length ? 'apply' : 'clear');
        return;
      }
      var pageLink = event.target.closest && event.target.closest('[data-ch-filter-results][data-ch-filter-owner="sale-maceteros"] .ch-sm-pagination a');
      if (pageLink) {
        event.preventDefault();
        swapResults(pageLink.href);
      }
    });

    drawer.addEventListener('click', function (event) {
      if (event.target.closest('[data-ch-sale-maceteros-close]')) { event.preventDefault(); closeDrawer(true); return; }
      var filter = event.target.closest('[data-ch-sale-maceteros-filter]');
      if (filter) {
        event.preventDefault();
        if (filter.getAttribute('aria-disabled') === 'true') return;
        var group = filter.getAttribute('data-group');
        var tag = filter.getAttribute('data-tag');
        if (selected[group] === tag) delete selected[group];
        else selected[group] = tag;
        renderDrawer();
        return;
      }
      var sort = event.target.closest('[data-ch-sale-maceteros-sort]');
      if (sort) {
        event.preventDefault();
        selectedSort = sort.getAttribute('data-ch-sale-maceteros-sort') || defaultSort;
        renderDrawer();
      }
    });

    drawer.addEventListener('keydown', function (event) {
      if (event.key === 'Tab' && drawer.classList.contains('is-open')) {
        var items = focusables();
        if (!items.length) { event.preventDefault(); panel.focus(); return; }
        var first = items[0], last = items[items.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });

    // B9: el movimiento dentro de los grupos de botones de opcion pasa a la capa
    // compartida, que agrega Inicio y Fin y deja una sola parada de tabulacion
    // por grupo. Este owner solo aporta su vocabulario de teclas y su estado.
    shared('bindRadioKeyboard')(drawer, function (next) {
      var filterTag = next.getAttribute('data-tag');
      var filterGroup = next.getAttribute('data-group');
      if (filterTag && filterGroup) selected[filterGroup] = filterTag;
      var sortValue = next.getAttribute('data-ch-sale-maceteros-sort');
      if (sortValue) selectedSort = sortValue;
      renderDrawer();
    }, ['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft']);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(true);
    });

    var clear = drawer.querySelector('[data-ch-sale-maceteros-clear]');
    if (clear) clear.addEventListener('click', function (event) {
      event.preventDefault();
      selected = {};
      applied = {};
      selectedSort = appliedSort = defaultSort;
      renderDrawer();
      renderActivePage();
      swapResults(buildUrl({}, defaultSort), true, true, 'clear');
    });

    if (applyButton) applyButton.addEventListener('click', function (event) {
      event.preventDefault();
      applied = copySelection(selected);
      appliedSort = selectedSort;
      renderActivePage();
      swapResults(buildUrl(applied, appliedSort), true, true, 'apply');
    });

    window.addEventListener('popstate', function () {
      selected = selectionFromPath(window.location.pathname);
      applied = copySelection(selected);
      selectedSort = appliedSort = new URLSearchParams(window.location.search).get('sort_by') || defaultSort;
      renderDrawer();
      renderActivePage();
      swapResults(window.location.href, false);
    });

    renderDrawer();
    renderActivePage();
    syncOpeners(false);
    var initialTotal = resultsTotal(root);
    if (initialTotal != null) setGridCount(initialTotal);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
